import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    DialogTitle,
    IconButton,
    DialogActions,
    DialogContent,
    Dialog,
    Button,
    Grid
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { connect } from "react-redux";
import { getVehicleNumberValuesDWeb } from "../../../utils/utils";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const useStyles = makeStyles((theme) => ({

    dialogTitleV1: {
        "& .MuiTypography-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end'
        },
        paddingLeft: 16,
        paddingRight: 6,
        paddingBottom: '0px !important',
        paddingTop: '6px !important'
    },
    closeIcon: {
        width: 22,
        height: 22,
        opacity: 0.5,
        color: '#848484'
    },
    divInactiveContainer: {
        padding: 24,
        borderRadius: 7,
        backgroundColor: '#fde2b8'
    },
    divBlacklistContainer: {
        padding: 24,
        borderRadius: 7,
        backgroundColor: '#f8cece'
    },
    divContainer: {
        marginTop: 24
    },
    divAlignTruck: {
        display: 'flex',
        fontSize: 24,
        fontWeight: 'bold',
        color: '#0a142a'
    },
    imgContainer: {
        padding: 10,
        backgroundColor: '#F1F3F6',
        borderRadius: 4
    },
    imgV1: {
        width: 34,
        height: 34
    },
    mlV1: {
        marginLeft: 8
    },
    inactiveDot: {
        color: '#adadad',
        fontSize: 18
    },
    blacklistDot: {
        color: '#e61b1b',
        fontSize: 18
    },
    textV1: {
        marginLeft: 12,
        fontSize: 16,
        color: '#0a142a'
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center'
    },
    dialogContentV1: {
        paddingTop: '0px !important',
        paddingBottom: '32px !important',
        paddingLeft: 32,
        paddingRight: 32
    },
    closeButton: {
        padding: 10
    },
    paper1: {
        borderRadius: 16
    },
    paperWidth: {
        width: '444px !important',
        maxWidth: '444px !important'
    },
    fwBold: {
        fontWeight: 'bold'
    },
    divContact: {
        fontSize: 16,
        marginTop: 16,
        color: '#0a142a'
    },
    number: {
        color: '#0033cc',
        fontWeight: 600
    },
    mtV1: {
        marginTop: 4
    },
    buttonV1: {
        borderRadius: 8,
        backgroundColor: '#edf0f5',
        color: '#656b77',
        fontSize: 14,
        fontWeight: 600,
        border: 'none',
        paddingTop: 16,
        paddingBottom: 16,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#edf0f5'
        }
    },
    dialogActionsV1: {
        padding: '16px !important',
        paddingTop: '0px !important'
    },
    divV1: {
        marginTop: 21,
        fontSize: 18,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center'
    },
    divV2: {
        color: '#2c5de5',
        marginLeft: 6
    },
    imgV2: {
        width: 252,
        height: 58
    },
    divV3: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    }

}));


const FastTagTruckInfoDialog = ({ open, onClose, fastag }) => {

    const [dialogOpen, setDialogOpen] = useState(open);
    const [truckInfoData, setTruckInfoData] = useState({});

    const classes = useStyles();

    useEffect(() => {

        if (fastag && fastag.singleFastTagDetails) {
            setTruckInfoData(fastag.singleFastTagDetails);
        }

    }, [open, fastag.singleFastTagDetails]);

    const handleDialogClose = () => {
        setDialogOpen(false);
        onClose();
    }


    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={dialogOpen} onClose={handleDialogClose}
                classes={{ paper: classes.paper1, paperWidthXs: classes.paperWidth }}
            >

                <DialogTitle className={classes.dialogTitleV1}>
                    <div>
                        <IconButton onClick={handleDialogClose} className={classes.closeButton} >
                            <CloseIcon className={classes.closeIcon} />
                        </IconButton>
                    </div>
                </DialogTitle>

                <DialogContent className={classes.dialogContentV1}>

                    {truckInfoData && truckInfoData.status && truckInfoData.status.toLowerCase() == "unregistered" &&
                        <div className={classes.divV3} >
                            <img src={`${process.env.PUBLIC_URL}/assets/images/fast-tag-icon.png`} alt="FastTag" className={classes.imgV2} />
                            <div className={classes.divV1} >
                                <div className={classes.divAlign}>
                                    {truckInfoData && truckInfoData.vehicleNumber && getVehicleNumberValuesDWeb(truckInfoData.vehicleNumber).map((truckNumber, index) => (
                                        <div className={index == (getVehicleNumberValuesDWeb(truckInfoData.vehicleNumber).length - 1) ? classes.divV2 : ""} >{truckNumber}</div>
                                    ))}
                                </div>
                                <div>&nbsp;is not linked with FASTag</div>
                            </div>
                        </div>
                    }

                    {truckInfoData && truckInfoData.status && truckInfoData.status.toLowerCase() != "unregistered" &&
                        <>
                            <Grid container wrap="nowrap" alignItems="center" justifyContent="space-between">

                                <Grid container wrap="nowrap" direction="column">
                                    <Grid item>
                                        <div className={classes.divAlignTruck}>
                                            {truckInfoData && truckInfoData.vehicleNumber && getVehicleNumberValuesDWeb(truckInfoData.vehicleNumber).map((truckNumber, index) => (
                                                <div className={index == 0 ? "" : classes.mlV1} >{truckNumber}</div>
                                            ))}
                                        </div>
                                    </Grid>
                                    <Grid item className={classes.mtV1}>
                                        <div className={classes.divAlign}>
                                            {truckInfoData && truckInfoData.status && truckInfoData.status.toLowerCase() == "inactive" &&
                                                <>
                                                    <FiberManualRecordIcon className={classes.inactiveDot} />
                                                    <div className={classes.textV1}>Inactive</div>
                                                </>
                                            }
                                            {truckInfoData && truckInfoData.status && truckInfoData.status.toLowerCase() == "blacklisted" &&
                                                <>
                                                    <FiberManualRecordIcon className={classes.blacklistDot} />
                                                    <div className={classes.textV1}>Blacklisted</div>
                                                </>
                                            }
                                        </div>
                                    </Grid>
                                </Grid>

                                <Grid item>
                                    <div className={classes.imgContainer}>
                                        <img src={truckInfoData && truckInfoData.bankIconUrl ? truckInfoData.bankIconUrl : ""} className={classes.imgV1} ></img>
                                    </div>
                                </Grid>

                            </Grid>

                            <div className={classes.divContainer}>
                                {truckInfoData && truckInfoData.status && truckInfoData.status.toLowerCase() == "inactive" &&
                                    <div className={classes.divInactiveContainer}>
                                        Your Fastag is <span className={classes.fwBold}>Inactive</span>. Please contact the issuing Bank to activate it
                                    </div>
                                }
                                {truckInfoData && truckInfoData.status && truckInfoData.status.toLowerCase() == "blacklisted" &&
                                    <div className={classes.divBlacklistContainer}>
                                        Your Fastag is <span className={classes.fwBold} >Blacklisted</span>. Please contact the issuing Bank to activate it
                                    </div>
                                }
                            </div>

                            <div className={classes.divContact} >Bank contact Number:&nbsp;&nbsp;<span className={classes.number}>+91-{truckInfoData && truckInfoData.bankPhoneNumber ? truckInfoData.bankPhoneNumber : ""}</span></div>
                        </>
                    }

                </DialogContent>

                {truckInfoData && truckInfoData.status && truckInfoData.status.toLowerCase() == "unregistered" &&
                    <DialogActions className={classes.dialogActionsV1}>
                        <Button variant="outlined" fullWidth className={classes.buttonV1} onClick={handleDialogClose} >Close</Button>
                    </DialogActions>
                }

            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

});
export default connect(mapStateToProps, mapDispatchToProps)(FastTagTruckInfoDialog);